import React, { useMemo, useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";
import { Link } from "../../components/LinkIcon";
import Select, { Option } from "rc-select";
import { useNavigate } from "react-router";
import { jobs } from "./jobs";

export const JoinusJobs = () => {
  const { t } = useTranslation();
  const [city, setCity] = useState("all");
  const [jobType, setJonTypeCity] = useState("all");
  const nav = useNavigate();

  const enterDetail = (id) => {
    nav(`/joinus/${id}`);
  };
  const onChangeCity = (e) => {
    let value;
    if (e && e.target) {
      ({ value } = e.target);
    } else {
      value = e;
    }
    setCity(value);
  };
  const onChangeJobType = (e) => {
    let value;
    if (e && e.target) {
      ({ value } = e.target);
    } else {
      value = e;
    }
    setJonTypeCity(value);
  };
  const jobsType = [
    {
      label: t("joinus.jobs.select.type-all"),
      value: "all",
    },
    {
      label: t("joinus.jobs.select.type-product"),
      value: "product",
    },
    {
      label: t("joinus.jobs.select.type-business"),
      value: "business",
    },
    {
      label: t("joinus.jobs.select.type-other"),
      value: "other",
    },
  ];
  const cityType = [
    {
      label: t("joinus.jobs.select.city-all"),
      value: "all",
    },
    {
      label: t("joinus.jobs.select.city-beijing"),
      value: "beijing",
    },
    {
      label: t("joinus.jobs.select.city-shanghai"),
      value: "shanghai",
    },
    {
      label: t("joinus.jobs.select.city-shenzhen"),
      value: "shenzhen",
    },
  ];
  const filterJobs = useMemo(() => {
    return jobs.filter((job) => {
      if (job.city === city || city === "all" || job.city.indexOf(city) > -1) {
        if (job.type === jobType || jobType === "all") {
          return job;
        }
      }
    });
  }, [city, jobType]);
  const filterJobsType = useMemo(() => {
    if (city === "shanghai" || city === "shenzhen") {
      return [
        {
          label: t("joinus.jobs.select.type-all"),
          value: "all",
        },
        {
          label: t("joinus.jobs.select.type-business"),
          value: "business",
        },
      ];
    } else {
      return jobsType;
    }
  }, [city, jobsType, t]);
  return (
    <div>
      <section>
        <div className="joinus-jobs">
          <Title title={t("joinus.jobs.title")} />
          <div className="jobs-select-warp">
            <Select
              value={city}
              onChange={onChangeCity}
              placeholder="城市"
              className="select-style"
            >
              {cityType.map((item) => {
                return (
                  <Option
                    key={item.value}
                    value={item.value}
                    className="select-option"
                  >
                    <span className="label">{item.label}</span>
                  </Option>
                );
              })}
            </Select>
            <Select
              value={jobType}
              onChange={onChangeJobType}
              placeholder="岗位"
              className="select-style"
              style={{ marginLeft: 10 }}
            >
              {filterJobsType.map((item) => {
                return (
                  <Option
                    key={item.value}
                    value={item.value}
                    className="select-option"
                  >
                    <span className="label">{item.label}</span>
                  </Option>
                );
              })}
            </Select>
          </div>

          <div className="joinus-jobs-warp">
            {filterJobs.map((job) => {
              return (
                <div className="jobs-item" onClick={() => enterDetail(job.id)}>
                  <div className="job-title-warp">
                    <span className="job-title">{t(job.title)}</span>
                    <span className="job-salary">{t(job.salary)}</span>
                  </div>
                  <div className="job-info">{t(job.info)}</div>
                  <Link>{t("joinus.jobs.button-apply")}</Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
